module.exports = __webpack_public_path__ + "img/_belarus.9e25139f.png";